import React, { useEffect, useReducer, useState } from "react";
/// Scroll
// import PerfectScrollbar from "react-perfect-scrollbar";
import Collapse from "react-bootstrap/Collapse";
/// Link
import { Link } from "react-router-dom";
import logoImg from "../../../images/logo.svg";
import { MenuList, VendorMenuList } from "../../Enums/Menu";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { useDispatch, useSelector } from "react-redux";
import { Translate } from "../../Enums/Tranlate";
import { setSearch } from "../../../store/actions/AuthActions";

const reducer = (previousState, updatedState) => ({
	...previousState,
	...updatedState,
});

const initialState = {
	active: "",
	activeSubmenu: "",
};

const SideBar = ({ toggle, setToggle }) => {
	const [active, setActive] = useState("");
	const dispatch = useDispatch();
	const [state, setState] = useReducer(reducer, initialState);
	const lang = useSelector((state) => state.auth?.lang);
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const [hideOnScroll, setHideOnScroll] = useState(true);

	useScrollPosition(
		({ prevPos, currPos }) => {
			const isShow = currPos.y > prevPos.y;
			if (isShow !== hideOnScroll) setHideOnScroll(isShow);
		},
		[hideOnScroll]
	);

	const handleMenuActive = (status) => {
		dispatch(setSearch(""));
		setState({ active: status });
		if (
			state.active === status &&
			MenuList.filter((res) => res?.title === status)[0]?.hasOwnProperty(
				"content"
			)
		) {
			setState({ active: "" });
		}
	};

	useEffect(() => {
		let page = window.location.pathname;
		let filter =
			Auth?.type === "admin"
				? MenuList?.filter((res) => `${res.to}` === page?.split("/")[1])
				: VendorMenuList?.filter((res) => `${res.to}` === page);

		if (filter.length > 0) handleMenuActive(filter[0].title);
	}, [window.location.pathname]);

	return (
		<div className={`deznav ${toggle ? "show-menu" : ""}`}>
			<Link to="/" className="brand-logo">
				<img
					className="brand-title m-auto"
					src={logoImg}
					width={100}
					height={120}
					alt="logo"
					style={{
						borderRadius: "0",
					}}
				/>
			</Link>
			<div className="mobile-button">
				<div className="w-100 d-flex justify-content-between align-items-center">
					<Link to="/">
						<img
							className="logo m-auto"
							src={logoImg}
							alt="logo"
							style={{
								borderRadius: "0",
							}}
						/>
					</Link>
					<div
						onClick={() => setToggle((prev) => !prev)}
						style={{ fontSize: "24px" }}
						className={`${toggle ? "is-active" : ""}`}>
						<i className="la la-angle-double-right"></i>
					</div>
				</div>
			</div>
			<div className="deznav-scroll">
				<ul className="metismenu" id="menu">
					{Auth?.type === "admin" &&
						MenuList.map((data, index) => {
							let menuClass = data.classsChange;
							if (data.content && data.content.length > 0) {
								if (
									data?.content
										?.map((res) => res?.role)
										.some((res) => isExist(`view_${res}`)) ||
									true
								) {
									return (
										<li
											className={` ${
												state.active === data.title ? "mm-active" : ""
											}`}
											key={index}>
											<>
												<Link
													to={"#"}
													className="has-arrow d-flex justify-content-between position-relative"
													onClick={() => {
														handleMenuActive(data.title);
													}}>
													<div>
														{state.active === data.title
															? data.iconActive
															: data.iconDeactive}
														<span className="nav-text">
															{Translate[lang][data.text]}
														</span>
													</div>
													{state.active === data.title ? (
														<svg
															width="16"
															height="16"
															viewBox="0 0 16 16"
															fill="none"
															xmlns="http://www.w3.org/2000/svg">
															<path
																d="M3.59999 9.69434L7.22222 6.07211C7.64999 5.64434 8.34999 5.64434 8.77777 6.07211L12.4 9.69434"
																stroke="white"
																strokeWidth="0.833333"
																strokeMiterlimit="10"
																strokeLinecap="round"
																strokeLinejoin="round"
															/>
														</svg>
													) : (
														<svg
															width="16"
															height="16"
															viewBox="0 0 16 16"
															fill="none"
															xmlns="http://www.w3.org/2000/svg">
															<path
																d="M12.4 6.30566L8.77778 9.92789C8.35001 10.3557 7.65001 10.3557 7.22223 9.92789L3.60001 6.30566"
																stroke="#292D32"
																strokeWidth="0.833333"
																strokeMiterlimit="10"
																strokeLinecap="round"
																strokeLinejoin="round"
															/>
														</svg>
													)}
												</Link>
												<Collapse
													in={state.active === data.title ? true : false}>
													<ul
														className={`${
															menuClass === "mm-collapse" ? "mm-show" : ""
														}`}>
														{data.content?.map((data, index) => {
															if (isExist(`view_${data?.role}`) || true) {
																return (
																	<li
																		key={index}
																		className={`${
																			state.activeSubmenu === data.title
																				? "mm-active"
																				: ""
																		}`}>
																		<Link
																			to={data.to}
																			onClick={() => {
																				dispatch(setSearch(""));
																				setToggle(false);
																				setActive(data.text);
																			}}
																			className={`${
																				active === data.text
																					? "active-link"
																					: ""
																			}`}>
																			{Translate[lang][data.text]}
																		</Link>
																	</li>
																);
															}
														})}
													</ul>
												</Collapse>
											</>
										</li>
									);
								}
							} else if (
								data?.title === "Dashboard" ||
								true ||
								isExist(`view_${data?.role}`)
							) {
								return (
									<li
										className={` ${
											state.active === data.title ? "mm-active" : ""
										}`}
										key={index}>
										<Link
											to={data.to}
											className="d-flex"
											onClick={() => {
												setToggle(false);
												handleMenuActive(data.title);
											}}>
											{state.active === data.title
												? data.iconActive
												: data.iconDeactive}
											<span className="nav-text">
												{Translate[lang][data.text]}
											</span>
										</Link>
									</li>
								);
							}
						})}
					{Auth?.type === "vendor" &&
						VendorMenuList.map((data, index) => (
							<li
								className={` ${state.active === data.title ? "mm-active" : ""}`}
								key={index}>
								<Link
									to={data.to}
									className="d-flex"
									onClick={() => {
										setToggle(false);
										handleMenuActive(data.title);
									}}>
									{state.active === data.title
										? data.iconActive
										: data.iconDeactive}
									<span className="nav-text">{Translate[lang][data.text]}</span>
								</Link>
							</li>
						))}
				</ul>
			</div>
		</div>
	);
};

export default SideBar;
